import React, { useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50 text-gray-900 min-h-screen overflow-hidden">
      <Navbar />

      <section className="min-h-screen flex items-center justify-center relative px-6 lg:px-12">
        <div className="absolute inset-0 bg-black">
          <div className="absolute inset-0 opacity-20">
            <div 
              className="w-full h-full"
              style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%234A90E2' fill-opacity='0.15'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                backgroundSize: '60px 60px'
              }}
            ></div>
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black"></div>
          
          {/* Floating particles */}
          <div className="absolute top-20 left-10 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl animate-float"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-float-delayed"></div>
        </div>

        <div className="max-w-3xl mx-auto text-center relative z-10">
          {/* 404 Number */}
          <h1 className="text-9xl md:text-[200px] font-bold text-blue-500 mb-6 leading-none" style={{ fontWeight: 700 }}>
            404
          </h1>
          
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight">
            Page Not Found
          </h2>
          
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed">
            The page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              onClick={() => navigate(-1)}
              className="bg-gray-100 hover:bg-gray-100 text-gray-900 border border-gray-3000 px-8 py-6 transition-all duration-300"
            >
              <ArrowLeft className="mr-2" size={20} />
              Go Back
            </Button>
            <Link to="/">
              <Button
                size="lg"
                className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-6 shadow-[0_0_30px_rgba(74,144,226,0.4)] hover:shadow-[0_0_40px_rgba(74,144,226,0.6)] transition-all duration-300 w-full sm:w-auto"
              >
                <Home className="mr-2" size={20} />
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
